import {
    FETCH_CENTER_APPOINTMENTS_SUCCESS,
    FETCH_CENTER_DOCTORS_SUCCESS,
    FETCH_CENTER_INFO_SUCCESS, FETCH_CENTER_ROOMS_SUCCESS} from "../actions/ActionTypes"
import initialState from "./InitialState"

export const CenterInfoReducer = (state = initialState.centerInfo, action: any) => {
    switch (action.type) {
        case FETCH_CENTER_INFO_SUCCESS:
            return { ...state, center: action.center };
        case FETCH_CENTER_ROOMS_SUCCESS:
            return { ...state, rooms: action.rooms };
        case FETCH_CENTER_DOCTORS_SUCCESS:
            return { ...state, doctors: action.doctors };
        case FETCH_CENTER_APPOINTMENTS_SUCCESS:
            return { ...state, appointments: action.appointments };
        default:
            return state;
    }
};